<div class="store-cache-to-file-container">
    <div *ngFor="let item of data" class="file-item">
        <tam-store-cache-to-file-widget [config]="item"></tam-store-cache-to-file-widget>
    </div>
</div>